import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_AI_SHARE_HEADLINE_BANDIT = defineFcm('ai_share_headline_bandit')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				prompt: { type: 'string' },
				model: { type: 'string' }, // FIXME should this be an enum?
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
